import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel';
import Header from './components/header.js';
import Footer from './components/footer.js';
import './GalleryPage.css';

class GalleryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gallery: null,
      loading: true,
      error: null,
      activeIndex: 0,
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentDidMount() {
    const { slug } = this.props.match.params;

    fetch('/galleries.json')
      .then(r => {
        if (!r.ok) throw new Error(`Could not load galleries (HTTP ${r.status})`);
        return r.json();
      })
      .then(data => {
        const found = data.find(g => g.slug === slug);
        if (!found) throw new Error(`Gallery "${slug}" not found.`);
        this.setState({ gallery: found, loading: false });
      })
      .catch(err => this.setState({ error: err.message, loading: false }));
  }

  handleSelect(selectedIndex) {
    this.setState({ activeIndex: selectedIndex });
  }

  render() {
    const { gallery, loading, error, activeIndex } = this.state;

    return (
      <div>
        <Header />

        <div className="container">
          <div className="row">
            <div>&nbsp;</div>
          </div>
        </div>

        <div className="container">

          {/* Back link */}
          <div className="row">
            <div className="col-sm-12">
              <Link to="/photography" className="gallery-back-link">
                ← All Galleries
              </Link>
            </div>
          </div>

          {loading && (
            <div className="row">
              <div className="col-sm-12 gallery-status">
                <div className="gallery-spinner" />
                <p>Loading gallery…</p>
              </div>
            </div>
          )}

          {error && (
            <div className="row">
              <div className="col-sm-12 gallery-status">
                <p>⚠ {error}</p>
                <Link to="/photography">← Back to Galleries</Link>
              </div>
            </div>
          )}

          {!loading && !error && gallery && (
            <>
              {/* Title */}
              <div className="row">
                <div className="col-sm-12 gallery-header">
                  <h1>{gallery.title}</h1>
                  {gallery.description && (
                    <p className="gallery-description">{gallery.description}</p>
                  )}
                  <p className="gallery-count">
                    {activeIndex + 1} / {gallery.images.length}
                  </p>
                </div>
              </div>

              {/* Carousel — same pattern as your original Photography.js */}
              <div className="row">
                <div className="col-sm-12">
                  <Carousel
                    activeIndex={activeIndex}
                    onSelect={this.handleSelect}
                    interval={null}
                    indicators={gallery.images.length <= 30}
                    keyboard={true}
                    touch={true}
                  >
                    {gallery.images.map((img, i) => (
                      <Carousel.Item key={img.src}>
                        <img
                          className="d-block w-100"
                          src={img.src}
                          alt={img.title || `Photo ${i + 1}`}
                          loading={i < 3 ? 'eager' : 'lazy'}
                        />
                        {(img.title || img.description) && (
                          <Carousel.Caption>
                            {img.title && <h3>{img.title}</h3>}
                            {img.description && <p>{img.description}</p>}
                          </Carousel.Caption>
                        )}
                      </Carousel.Item>
                    ))}
                  </Carousel>
                </div>
              </div>

              {/* Thumbnail strip */}
              <div className="row">
                <div className="col-sm-12">
                  <div className="gallery-thumbs">
                    {gallery.images.map((img, i) => (
                      <button
                        key={img.src}
                        className={`gallery-thumb${i === activeIndex ? ' gallery-thumb--active' : ''}`}
                        onClick={() => this.handleSelect(i)}
                        aria-label={`Go to photo ${i + 1}${img.title ? ': ' + img.title : ''}`}
                      >
                        <img src={img.src} alt="" loading="lazy" />
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <Footer />
      </div>
    );
  }
}

export default GalleryPage;
